// extracted by mini-css-extract-plugin
export var completionBody = "_mh-2";
export var completionCard = "_mh-0";
export var completionFooter = "_mh-3";
export var completionTitle = "_mh-1";